import { Suspense, useEffect, useRef, useState } from "react";
import { AddSGBPCategoryData } from "./data/AddSGBPCategory.data";
import DataLoader from "../../../../components/ui/dataLoader/DataLoader";
import Accordion from "../../../../components/Accordion/Accordion";
import FormCreator from "../../../../components/Forms/FormCreator";
import Buttons from "../../../../components/ui/button/Buttons";
import { useGetL1DropdownByChannelIdMutation, useLazyGetAllDropdownForCRUDCategoryQuery, useSubmitCategoryCriteriaCertificateMappingInformationMutation } from "../../../../app/services/Crud/crudApi";
import { setAllDropDownField } from "../../Utils/setAllDropDownField";
import { applyCertificateTemplateOptions, getCertificateTemplateOptions, hideAndShowFields } from "../../Utils/setFormUtils";
import SwalAlert from "../../../../services/swalService/SwalService";
import { useNavigate } from "react-router-dom";

const AddSGBPCategory = () => {
  const addSGBPCategoryRefs = useRef();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(AddSGBPCategoryData);
  const { error, success } = SwalAlert();
  const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading },] = useLazyGetAllDropdownForCRUDCategoryQuery();
  const [getL1DropdownByChannelId] = useGetL1DropdownByChannelIdMutation();
  const [submitMapping, { data: mappingData, isLoading: mappingLoading },] = useSubmitCategoryCriteriaCertificateMappingInformationMutation();

  useEffect(() => {
    getDropdowns();
  }, [])

  useEffect(() => {
    if (!dropdownLoading && dropdownData) {
      setAllDropDownField(dropdownData);
    }
  }, [dropdownLoading, dropdownData]);

  useEffect(() => {
    if (!mappingLoading && mappingData) {
      if (mappingData?.errorMessage === "Criteria Mapping Already Exist") {
        error("Criteria Mapping Already Exist.");
      }
      else {
        success("Criteria Mapping added successfully.", "");
        navigate('/SGBPCategory')
      }
    }
  }, [mappingLoading, mappingData]);

  const handleSubmit = () => {
    const data = addSGBPCategoryRefs?.current?.getFormData();
    if (!data) {
      error("Please fill in all mandatory fields to continue.", "")
      return;
    }

    const request = {
      ChannelId: data.channel?.value || null,
      CategoryL1Id: data.category?.value || null,
      SubCategoryL2Id: data.channel?.value == 1 ? data.subCategory?.value : null,
      TypeL3Id: data.channel?.value == 1 ? data.type?.value : null,
      CriteriaCodeId: data.code?.value || null,
      CertificateTemplateId: data.certificateTemplate?.value || null,
      StatusId: 2,
    }
    submitMapping(request);
  };

  const handleFormFieldChange = async (dataField, value) => {
    let updatedForm = { ...formData };
    if (dataField === "channel") {
      updatedForm = hideAndShowFields(updatedForm, value);
      const apiResponse = await getL1DropdownByChannelId({ ChannelId: value?.value });
      const filterDropdown = apiResponse?.data?.map((item) => ({ value: item.id, label: item.name }));
      const categoryOptions = apiResponse?.data?.map((item) => ({ value: item.id, label: item.name })) || [];
      const templateOptions = getCertificateTemplateOptions(dropdownData, value?.value);
      // let updatedFormData = { ...updatedForm, initialState: { ...updatedForm.initialState, channel: value, category: null, subCategory: null, type: null, } };
      // updatedFormData = { ...updatedFormData, formFields: updatedFormData.formFields.map(field => field.id === "category" ? { ...field, fieldSetting: { ...field.fieldSetting, options: filterDropdown, }, } : field), };
      // setFormData(updatedFormData);
      setFormData((prev) => {
        let form = hideAndShowFields(prev, value);
        form = {
          ...form,
          initialState: {
            ...form.initialState,
            channel: value,
            category: null,
            subCategory: null,
            type: null,
            certificateTemplate: null,   // channel badlay tyare reset
          },
          formFields: form.formFields.map((field) =>
            field.id === "category"
              ? { ...field, fieldSetting: { ...field.fieldSetting, options: categoryOptions } }
              : field
          ),
        };
        return applyCertificateTemplateOptions(form, templateOptions);
      });
    }
    else {
      // update field value safely
      // setFormData((prev) => ({ ...prev, ...updatedForm, initialState: { ...prev.initialState, ...updatedForm.initialState, [dataField]: value, }, }));
      setFormData((prev) => ({ ...prev, initialState: { ...prev.initialState, [dataField]: value }, }));
    };
  };

  const handleBack = () => {
    navigate('/SGBPCategory')
  }
  return (
    <div className="add-requirement">
      <Suspense fallback={<DataLoader />}>
        <Accordion
          title="Add New Criteria Mapping"
          className="mb-4"
          button={false}
          accordion={false}
        >
          <div className="row">
            {dropdownData &&
              <FormCreator
                ref={addSGBPCategoryRefs}
                {...formData}
                onFormFieldValueChange={handleFormFieldChange}
              />
            }
          </div>
        </Accordion>
        <div className="add-requirement-btn-wrapper">
          <Buttons
            buttonText="Back"
            buttonTypeClassName="btn btn-secondary mb-2"
            onClick={handleBack}
          />
          <div className="save-btn-wrapper">
            <Buttons
              buttonText="Save"
              buttonTypeClassName="add-btn"
              onClick={handleSubmit}
            />
          </div>
        </div>

      </Suspense>
    </div>
  );
};

export default AddSGBPCategory;
